import type { GetCollaboratorsResponseType } from "@nlc/shared-types";

import { UserRoleEnum } from "@nlc/shared-types";

export const MOCKED_COLLABORATORS: GetCollaboratorsResponseType = {
  collaborators: [
    {
      avatar: "",
      brandIds: [],
      id: 1,
      name: "Mock User 1",
      roleId: UserRoleEnum.Collaborator,
    },
    {
      avatar: "",
      brandIds: [],
      id: 2,
      name: "Mock User 2",
      roleId: UserRoleEnum.Collaborator,
    },
  ],
};
